import type { LoungeMessage } from '@ppwr/convex/lounges/types'
import { Palette } from '@ppwr/poker'
import { formatChatTimestamp } from '../../../utils/dateFormatter'

export const AVATAR_COLORS = [
  Palette['Brand/Blue'],
  Palette['Brand/Pink'],
  Palette['Brand/Purple'],
  Palette['Brand/Maroon'],
  Palette['Brand/Orange'],
  Palette['Brand/Green']
] as const

export function memberAvatarColor(userId: string): string {
  let h = 0
  for (let i = 0; i < userId.length; i++) h = (h * 31 + userId.charCodeAt(i)) | 0
  return AVATAR_COLORS[Math.abs(h) % AVATAR_COLORS.length]
}

export const CHAT_GROUP_GAP_MS = 5 * 60 * 1000

export type ChatListItem =
  | { kind: 'header'; label: string; key: string }
  | { kind: 'message'; data: LoungeMessage; isFirstInGroup: boolean; isLastInGroup: boolean }

export function buildChatItems(messages: LoungeMessage[]): ChatListItem[] {
  const items: ChatListItem[] = []
  for (let i = 0; i < messages.length; i++) {
    const msg = messages[i]
    const prev = messages[i - 1]
    const next = messages[i + 1]
    if (!prev || msg.createdAt - prev.createdAt > CHAT_GROUP_GAP_MS) {
      items.push({ kind: 'header', label: formatChatTimestamp(msg.createdAt), key: `hdr-${msg._id}` })
    }
    const isFirstInGroup = !prev || prev.userId !== msg.userId || msg.createdAt - prev.createdAt > CHAT_GROUP_GAP_MS
    const isLastInGroup =
      !next ||
      next.userId !== msg.userId ||
      next.createdAt - msg.createdAt > CHAT_GROUP_GAP_MS ||
      msg.messageKind === 'system' ||
      next.messageKind === 'system'
    items.push({ kind: 'message', data: msg, isFirstInGroup, isLastInGroup })
  }
  return items
}

const EMOJI_ONLY_RE = /^[\p{Emoji_Presentation}\p{Extended_Pictographic}‍️\s]+$/u

export function isEmojiOnly(text: string): boolean {
  const trimmed = text.trim()
  return trimmed.length > 0 && EMOJI_ONLY_RE.test(trimmed)
}
